import graphql__a987129d3b303e0ff558 from "./__generated__/DeleteBwaMonthDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import Section from "../form/Section";
import FormDialog from "./FormDialog";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import type {DeleteBwaMonthDialogMutation} from "./__generated__/DeleteBwaMonthDialogMutation.graphql";

type Props = {
    bwaMonth: {
        month: string
    }
    onClose: (changed: boolean) => void
}

const DeleteBwaMonthDialog: React.FC<Props> = ({bwaMonth, onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = () => {
        commitMutationWithErrorHandling<DeleteBwaMonthDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__a987129d3b303e0ff558,
                variables: {input: {id: bwaMonth.month}},
                onCompleted: (_, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    onClose(true);
                },
                onError: (error) => {
                    console.error(error);
                    onClose(false);
                },
            },
            addError,
            {customErrorMessage: intl.formatMessage({id: 'errors.failedToRemoveBwaMonth'})}
        );
    };

    return (
        <FormDialog handleCloseDialog={() => onClose(false)}
                    handleSubmission={handleSubmission}
                    initialValues={{}}
                    headline={intl.formatMessage({id: 'dialog.DeleteBwaMonthDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.delete'})}
                    dangerous={true}>
            <Section>
                <p className="text-sm text-gray-600">
                    {intl.formatMessage({id: 'dialog.DeleteBwaMonthDialog.confirmMessage'}, {month: bwaMonth.month})}
                </p>
            </Section>
        </FormDialog>
    );
};

export default DeleteBwaMonthDialog;
